import { createSlice } from "@reduxjs/toolkit";
import { TEST_MODE } from "./enums";

const promotionsSlice = createSlice({
  name: "promotion",
  initialState: {
    forUser: TEST_MODE ? +localStorage.getItem("userId") : "loading",
    currency: null,
    cashback: null,
    firstDeposit: null,
    registration: null,
    startBot: null,
    welcome: null,
    freeSpins: null,
    campaigns: {},
    jackpots: {
      // mini: {},
      // major: {},
      // grand: {}
    }
  },
  reducers: {
    setCampaignsById(state, newAction) {
      const { id, data } = newAction.payload;
      state.campaigns[id] = data;
    },
    setCashback(state, newAction) {
      state.cashback = newAction.payload;
    },
    setBonusCurrency(state, newAction) {
      state.currency = newAction.payload;
    },
    setFirstDeposit(state, newAction) {
      state.firstDeposit = newAction.payload;
    },
    setRegistration(state, newAction) {
      state.registration = newAction.payload;
    },
    setStartBot(state, newAction) {
      state.startBot = newAction.payload;
    },
    setForUser(state, newAction) {
      state.forUser = newAction.payload;
    },
    setJackpots(state, newAction) {
      state.jackpots = newAction.payload;
    },
    setWelcome(state, newAction) {
      state.welcome = newAction.payload;
    },
    setFreeSpins(state, newAction) {
      state.freeSpins = newAction.payload;
    }
  }
});
export default promotionsSlice.reducer;

export const {
  setCashback,
  setFirstDeposit,
  setRegistration,
  setStartBot,
  setForUser,
  setJackpots,
  setWelcome,
  setBonusCurrency,
  setFreeSpins,
  setCampaignsById
} = promotionsSlice.actions;
